/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import defaults from '../defaults.tsx';
import type { Middleware, MiddlewareResult, StoreState } from '../types.tsx';
import update from './update.tsx';

const applyMiddleware = <TState,>(
	storeState: StoreState<TState>,
	middlewares: Iterable<Middleware> | ArrayLike<Middleware>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
): ((...arg: any) => MiddlewareResult) =>
	Array.from(middlewares)
		.concat(update)
		.reduceRight((next, mw) => mw(storeState)(next), defaults.mutator);

export default applyMiddleware;
